import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { headingSx, valueSx } from "../../styles";

export interface OrderSummaryHeaderLineOneProps {
  gridSize: number;
  activeHeaders: {
    name: string;
    dataTestId: string;
    value:
      | string
      | false
      | JSX.Element
      | (string | JSX.Element)[]
      | undefined
      | null;
  }[];
}

const OrderSummaryHeaderLineOne = (props: OrderSummaryHeaderLineOneProps) => {
  const { activeHeaders, gridSize } = props;
  const theme = useTheme();
  return (
    <Grid container spacing={4} padding={4} px={4}>
      {activeHeaders.map((header) => (
        <Grid key={header.dataTestId} size={{ xs: gridSize }}>
          <Typography sx={headingSx(theme)} data-testid={header.dataTestId}>
            {header.name}
          </Typography>
          <Typography
            sx={valueSx(theme)}
            data-testid={`${header.dataTestId}-value`}
          >
            {header.value}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default OrderSummaryHeaderLineOne;
